import type { UniclientComponent } from '@lemonade-hq/uniclient-chat';

export const checkEveryComponentOfType = (type: string, componentProps: UniclientComponent<string>[]): boolean => {
  return componentProps.every(item => (item as { type: string }).type === type);
};

export const isSingleComponentOfType = (type: string, componentProps: UniclientComponent<string>[]): boolean => {
  if (componentProps.length > 1 || componentProps.length === 0) return false;

  return checkEveryComponentOfType(type, componentProps);
};
